export default __webpack_public_path__ + "static/Bina-e07ea2e0f65e1630f077cc3c16401384.jpg";